<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
				<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
					[(ngModel)]="SchoolID"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector [ShowAll]="false" [Disabled]="loading"> </caass-schoolselector>
			</div>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onAddBellSchedule()">Add Bell Schedule</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onEditBellSchedule()">Edit Bell Schedule</button>
		<button [disabled]="loading" class="btn btn-primary" style="margin-left: 5px" (click)="onToggleBellSchedule()">
			{{ ToggleText }}
		</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstBellSchedule"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedBellSchedule"
		dataKey="BellScheduleID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--BellScheduleDesc-->
				<th>
					<p-columnFilter type="text" field="BellScheduleDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--Active-->
				<th>
					<p-columnFilter field="Active" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActive
								[ngModel]="value"
								[options]="lstActive"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="BellScheduleDesc">Name<p-sortIcon field="BellScheduleDesc"></p-sortIcon></th>
				<th pSortableColumn="Active">Active<p-sortIcon field="Active"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-BellSchedule>
			<tr [pSelectableRow]="BellSchedule" (dblclick)="onRowDblClick(BellSchedule)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ BellSchedule[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
